import { useState, useEffect, useMemo } from 'react';
import { glossaryService } from 'services/api';
import styles from './GlosarioModal.module.css';

// Normaliza para buscar sin tildes ni mayusculas
const norm = (s) => (s || '')
  .toLowerCase()
  .normalize('NFD').replace(/[̀-ͯ]/g, '');

// Hook: glosario de la plataforma (global, solo lectura para el propietario).
export function useGlossary() {
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    let alive = true;
    glossaryService.getAll()
      .then(r => { if (alive) setTerms(r.data?.terms || []); })
      .catch(() => { if (alive) setTerms([]); });
    return () => { alive = false; };
  }, []);

  return terms;
}

// Modal "Glosario" con buscador. Autocontenido (trae su propio overlay), se usa
// desde el portal del propietario (con o sin asamblea en curso).
export default function GlosarioModal({ onClose }) {
  const terms = useGlossary();
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(null);

  const filtered = useMemo(() => {
    if (!terms) return [];
    const nq = norm(q.trim());
    if (!nq) return terms;
    return terms.filter(t => norm(t.term).includes(nq) || norm(t.definition).includes(nq));
  }, [terms, q]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.glosario}`}
        onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className={styles.cabeceraTitulo}>
            <div className={styles.iconoCaja}>
              <i className={`fas fa-book ${styles.glifo}`} />
            </div>
            <h3 className={styles.titulo}>Glosario</h3>
          </div>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        <div className={`modal-body ${styles.cuerpo}`}>
          <p className={styles.intro}>
            Términos frecuentes de las asambleas y la propiedad horizontal.
          </p>

          <div className={styles.buscador}>
            <i className={`fas fa-search ${styles.buscadorIcono}`} />
            <input className={`form-control ${styles.buscadorCampo}`} value={q} onChange={e => setQ(e.target.value)}
              placeholder="Buscar término…" autoFocus />
          </div>

          {terms === null ? (
            <div className={styles.cargando}>
              <div className={`spinner ${styles.spinnerChico}`} />
            </div>
          ) : filtered.length === 0 ? (
            <div className={styles.vacio}>
              <i className={`fas fa-inbox ${styles.iconoAzul}`} />
              {q.trim() ? 'Ningún término coincide con tu búsqueda.' : 'Aún no hay términos en el glosario.'}
            </div>
          ) : (
            <div className={styles.lista}>
              {filtered.map(t => {
                const expanded = open === t.id;
                return (
                  <div key={t.id} className={styles.termino}>
                    <button onClick={() => setOpen(expanded ? null : t.id)}
                      className={styles.terminoBoton}>
                      <i className={`fas fa-book ${styles.terminoIcono}`} />
                      <span className={styles.terminoNombre}>{t.term}</span>
                      <i className={`fas fa-chevron-${expanded ? 'up' : 'down'} ${styles.terminoFlecha}`} />
                    </button>
                    {expanded && (
                      <div className={styles.definicion}>
                        {t.definition}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
